<section class="padding-30px-tb xs-padding-60px-tb blog-style1 bg-light-deep-yellow header-margin-top-medium" id="">
    <div class="container" *ngIf="!periodoActual">
        <div *ngIf="loading">
            <h2
                class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom text-center">
                Tropeando ganado para usted</h2>
            <div class="text-center">
                <img class="rounded mx-auto d-block" alt="" src="assets/images/cabalgando-200x200.gif">
            </div>
        </div>
    </div>
    <div class="container" *ngIf="periodoActual">
        <!-- title -->
        <!-- title -->
        <h2
            class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom text-center">
            {{periodoActual.descripcion}} </h2>
        <!-- end  title -->
        <div class="row margin-three">
            <form [formGroup]="filtrarForm" action="" method="post" (ngSubmit)="onSubmit()">
                <ng-multiselect-dropdown
                    class="medium-input border-radius-4 float-left width-20 md-width-90 margin-one-right"
                    [placeholder]="'Elegir categoría...'" [data]="categoriaList" formControlName="valor"
                    [settings]="dropdownSettings2" (onSelect)="onCategoriaSelect($event)"
                    (onDeSelect)="onCategoriaDeselect($event)" (onSelectAll)="onCategoriaSelectAll($event)"
                    (onDeSelectAll)="onCategoriaSelectAll($event)">
                </ng-multiselect-dropdown>
                <ng-multiselect-dropdown
                    class="medium-input border-radius-4 float-left width-20 md-width-90 margin-one-right"
                    [placeholder]="'Elegir marca...'" [data]="marcaList" formControlName="valor"
                    [settings]="dropdownSettings" (onSelect)="onMarcaSelect($event)"
                    (onDeSelect)="onMarcaDeselect($event)" (onSelectAll)="onMarcaSelectAll($event)"
                    (onDeSelectAll)="onMarcaSelectAll($event)">
                </ng-multiselect-dropdown>
                <ng-multiselect-dropdown
                    class="medium-input border-radius-4 float-left width-20 md-width-90 margin-one-right"
                    [placeholder]="'Elegir departamento...'" [data]="departamentoList" formControlName="valor"
                    [settings]="dropdownSettings" (onSelect)="onDepartamentoSelect($event)"
                    (onDeSelect)="onDepartamentoDeSelect($event)" (onSelectAll)="onDepartamentoSelectAll($event)"
                    (onDeSelectAll)="onDepartamentoSelectAll($event)">
                </ng-multiselect-dropdown>
                <button type="submit"
                    class="btn btn-large propClone btn-circle bg-dark-brown text-white">Mostrar</button>
            </form>
        </div>
        <div class="row row-lotes margin-two-top">
            <!-- item -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-nineteen-bottom" *ngFor="let subasta of subastas">
                <div class="item-post">
                    <h3 class="text-large text-center text-white bg-dark-brown font-weight-600">Lote {{
                        subasta.numero }} - ID {{ subasta.identificador }}</h3>
                    <!-- image -->
                    <div class="item-image">
                        <a [routerLink]="['/subastas', subasta.identificador]" routerLinkActive="active" class=""><img
                                *ngIf="subasta.imagenes.length > 0" class="" alt="" src="{{ subasta.imagenes[0].url }}"
                                data-img-size="(W)800px X (H)507px"></a>
                        <h3 *ngIf="subasta.vendido" class="text-center text-red font-weight-600 vendido"> VENDIDO </h3>
                    </div>
                    <!-- end image -->
                    <!-- details -->
                    <div class="bg-white  padding-10px-tb">
                        <div class="text-medium xs-text-large font-weight-800 text-center padding-seven">
                            <h3 class="text-center title-small xs-title-medium text-dark-brown font-weight-600">{{
                                subasta.establecimiento.nombre }}</h3>
                            <span class="width-100">CATEGORÍA: {{subasta.categoria}} </span><br>
                            <span class="width-100">CANTIDAD: {{ subasta.cantidad }} | PESO: {{ subasta.peso }}
                                kg.</span><br>
                            <span class="width-100">DPTO.:
                                {{ subasta.establecimiento.departamento.descripcion }}</span><br>
                            <span *ngIf="!(subasta.vendido) && (subasta.compraDirecta)">
                                <strong class="title-small xs-title-medium text-red"> Compra directa {{
                                    separadorMiles(subasta.precioCompraDirecta | currency : 'Gs. ':'symbol':'3.0-0') }} </strong><br>
                            </span>
                            <span *ngIf="(subasta.vendido) && (subasta.compraDirecta) && (subasta.precioVentaFinal > 0)">
                                <strong class="title-small xs-title-medium text-red"> Vendido {{
                                    separadorMiles(subasta.precioVentaFinal | currency : 'Gs. ':'symbol':'3.0-0') }} </strong><br>
                            </span>
                            <span *ngIf="!(subasta.vendido) && (subasta.enPeriodoPuja && subasta.subasta) && (subasta.ultimoMontoPujado == 0) && (subasta.precioBase > 0)">
                                <strong class="title-small xs-title-medium text-red"> Precio base {{
                                    separadorMiles(subasta.precioBase | currency : 'Gs. ':'symbol':'3.0-0') }} </strong><br>
                            </span>
                            <span *ngIf="!(subasta.vendido) && (subasta.enPeriodoPuja && subasta.subasta) && (subasta.ultimoMontoPujado > 0) && (subasta.ultimoMontoPujado >= subasta.precioBase)">
                                <strong class="title-small xs-title-medium text-red"> Ultima puja {{
                                    separadorMiles(subasta.ultimoMontoPujado | currency : 'Gs. ':'symbol':'3.0-0') }} </strong><br>
                            </span>
                            <span *ngIf="(subasta.vendido) && (subasta.subasta) && (subasta.precioVentaFinal > 0)">
                                <strong class="title-small xs-title-medium text-red"> Vendido {{
                                    separadorMiles(subasta.precioVentaFinal | currency : 'Gs. ':'symbol':'3.0-0') }} </strong><br>
                            </span>
                            <span
                                *ngIf="((subasta.enPeriodoPuja && subasta.subasta))  && !subasta.vendido && !subasta.periodoAleatorio && !subasta.finalizado"
                                class="width-100 text-black padding-ten"><i class="fas fa-clock"></i>
                                <strong class="text-large">
                                    <countdown (reached)="callback($event)" [text]="text"
                                        units="Days | Hours | Minutes | Seconds" end="{{ subasta.fechaFinPuja }}">
                                    </countdown>
                                </strong><br>
                            </span>
                            <span
                                *ngIf="!(subasta.compraDirecta) && !((subasta.enPeriodoPuja && subasta.subasta))  && !subasta.vendido && !subasta.periodoAleatorio && !subasta.finalizado"
                                class="width-100 text-deep-green padding-ten"><i class="fas fa-clock"></i>
                                <strong class="text-large">
                                    <countdown (reached)="callback($event)" [text]="text"
                                        units="Days | Hours | Minutes | Seconds" end="{{ subasta.fechaInicioPuja }}">
                                    </countdown>
                                </strong><br>
                            </span>
                            <span *ngIf="subasta.periodoAleatorio">
                                <strong class="title-small xs-title-medium text-black"><i class="fas fa-clock "></i>
                                    Estamos en el periodo aleatorio </strong>
                            </span>
                            <span *ngIf="subasta.finalizado && subasta.subasta">
                                <strong class="title-small xs-title-medium text-black"><i class="fas fa-clock "></i> La
                                    subasta ha finalizado </strong>
                            </span>
                        </div>
                        <div class="btn-dual text-center margin-five">
                            <a class="btn btn-large propClone btn-circle bg-deep-green text-white inner-link"
                                [routerLink]="['/subastas',subasta.identificador]" routerLinkActive="active"><span
                                    class="" id="">VER LOTE</span></a>
                        </div>
                    </div>
                    <!-- end details -->
                </div>
            </div>
            <!-- end item -->
        </div>
    </div>
</section>
<section class="padding-50px-tb bg-light-deep-yellow  xs-padding-60px-tb feature-style-31 border-none" id="">
    <div class="separator-line1 width-80 bg-dark-brown center-col  margin-five-bottom sm-margin-ten-bottom"></div>
    <div class="container">
        <div class="row">
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/como-funciona" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-info-circle title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Información</span>
                            <h3 class="text-large alt-font text-dark-gray ">Como funciona</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/condiciones-subasta" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-gavel title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Participar de subastas</span>
                            <h3 class="text-large alt-font text-dark-gray ">Condiciones</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-address-card title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Únase hoy mismo</span>
                            <h3 class="text-large alt-font text-dark-gray ">Registro</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-sign-in-alt title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">¿Ya está registrado?</span>
                            <h3 class="text-large alt-font text-dark-gray ">Ingresar</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
        </div>
    </div>
</section>
